/*
We'll use this eventbus to send data from grandchildren to parent
This is useful in the case where the Clinex / Trio test will need patient data
*/

import Vue from "vue";

export const EventBus = new Vue();
